// router path
export const ROOT = "/";
export const PAGE_404 = ROOT + "notFound";
export const REJOINDRE = ROOT + "nous-rejoindre";
export const NOTE = ROOT + "note-BAM";
export const ERROR_TOAST = "ERROR_TOAST";
export const CONTACTER = ROOT + "nous-contacter";
export const MAP = ROOT + "nos-agences";
export const SIMULATEUR = ROOT + "simulateur";
export const INSCRIPTION_ALREADY_CLIENT = ROOT + "inscription";
export const INSCRIPTION_OPTIONS = ROOT + "inscription-options";
export const FAQ = ROOT + "foire-aux-questions";
export const ESPACE_MEDIA = ROOT + "espace-media";
export const STEPS = ROOT + "credit";
export const URL_CLIENT = ROOT + "client/";
export const LOGIN = ROOT + "login";
export const MDP_OUBLIE = ROOT + "mdpOublie";
export const SECURITE = ROOT + "securite";
export const ASSURANCE = ROOT + "assurance";
export const SERVICE = ROOT + "services";
export const SOLUTION_ASSURANCE = ROOT + "solAss";
export const SOLUTION = ROOT + "solution";
export const AVANTAGE = ROOT + "avantages";
export const CREDIT = ROOT + "mobilite";
export const OFFRES = ROOT + "offres";
export const PARTENAIRE = ROOT + "verification";
export const MAINTENANCE = ROOT + "maintenance";
export const PEDAGOGIE = ROOT + "pedagogie";
export const CREDIT_FLEXIBILITE = ROOT + "flexibilite-credit";
export const CREDIT_FONCTIONNAIRE = ROOT + "credit-fonctionnaire";
export const CREDIT_ENTREPRISES = ROOT + "credit-entreprises/note-explicative";
export const CREDIT_PRO = ROOT + "credit-professionnel";
export const CREDIT_CONSO = ROOT + "credit-consommation";
export const CREDIT_RETRAITE = ROOT + "credit-retraite";
export const ENGAGEMENTS = ROOT + "engagements";

//Espace connecte
export const DEMANDES = URL_CLIENT + "demandes";
export const SIMULATEUR_CONNECTE = URL_CLIENT + "simulateur";
export const COMPTE = URL_CLIENT + "mon-compte";
export const FINANCE = URL_CLIENT + "financement";
